'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import text from 'I18n/utils/unescapedText';
import FontPicker from 'ContentComponents/cmv2/fields/FontPicker';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import ToolFieldset from 'DesignComponents/tool/ToolFieldset';
import ToolFormControl from 'DesignComponents/tool/ToolFormControl';
import { FONT } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { DEFAULT } from 'DesignData/enums/CustomWidgetFieldAttributes';
import { makeGetIsEmailOrAnyType, makeGetModulePath } from 'DesignData/selectors/customWidgetBuffers';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

class FontContentOptions extends PureComponent {
  constructor(...args) {
    super(...args);

    this.onDefaultChange = font => {
      this.props.editField({
        [DEFAULT]: font
      });
    };
  }

  render() {
    const {
      field,
      isEmailOrAnyType,
      modulePath,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: "custom-widget-editor-font-picker",
      children: /*#__PURE__*/_jsx(ToolFieldset, {
        children: /*#__PURE__*/_jsx(ToolFormControl, {
          children: /*#__PURE__*/_jsx(FontPicker, {
            buttonSize: "small",
            isEmailOrAnyType: isEmailOrAnyType,
            label: text(i18nKey(`defaultLabels.${FONT}`)),
            modulePath: modulePath,
            onFieldChange: this.onDefaultChange,
            readOnly: readOnly,
            showSizeUnit: true,
            value: field[DEFAULT]
          })
        })
      })
    });
  }

}

FontContentOptions.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  isEmailOrAnyType: PropTypes.bool,
  modulePath: PropTypes.string,
  readOnly: PropTypes.bool
};

function makeMapStateToProps() {
  const getIsEmailOrAnyType = makeGetIsEmailOrAnyType();
  const getModulePath = makeGetModulePath();
  return (state, props) => {
    return {
      isEmailOrAnyType: getIsEmailOrAnyType(state, props),
      modulePath: getModulePath(state, props)
    };
  };
}

export default connect(makeMapStateToProps, null)(FontContentOptions);